import React, { useContext, useState } from "react";
import { VILLAGES_OBJ } from "../../constants/constants";
import { AppContext } from "../../context";

function RentacarReservationInfo({ product }) {
  const info = useContext(AppContext);

  // if product has information such as reservation_time_range, pickup_loc and return_loc
  // it is coming from a reservation in the DB
  // otherwise, it is a product from the search grid and those params come from the filter (info context)
  let params = {};
  if (
    product.reservation_time_range &&
    product.pickup_loc &&
    product.return_loc
  ) {
    // product comes from the DB
    const timeRangeStr = product?.reservation_time_range;
    params.reservation_time_range = [
      timeRangeStr.split(",")[0].split('"')[1].slice(0, -3),
      timeRangeStr.split(",")[1].split('"')[1].slice(0, -3),
    ];

    params.pickup_loc = product?.pickup_loc;
    params.return_loc = product?.return_loc;

    params.transfer_loc = product?.ren_transfer_loc;
    params.transfer_time = product?.ren_transfer_time.split("T")[1].slice(0, 5);
  } else {
    // product comes from search
    params.reservation_time_range = info.rentacar?.reservation_time_range;
    params.pickup_loc = info.rentacar?.pickupLoc;
    params.return_loc = info.rentacar?.returnLoc;
    params.transfer_loc = info.rentacar?.transferLoc;
    params.transfer_time = info.rentacar?.transferTime._i;
  }

  const pickup_loc = VILLAGES_OBJ[params?.pickup_loc];
  const pickup_date = params?.reservation_time_range?.[0].split(" ")[0];
  const pickup_time = params?.reservation_time_range?.[0]
    ?.split(" ")[1]
    ?.slice(0, 5);

  const return_loc = VILLAGES_OBJ[params?.return_loc];
  const return_date = params?.reservation_time_range?.[1].split(" ")[0];
  const return_time = params?.reservation_time_range?.[1]
    ?.split(" ")[1]
    ?.slice(0, 5);

  const transfer_loc = params.transfer_loc;
  const transfer_time = params.transfer_time;

  return (
    <div>
      {transfer_loc !== "no_transfer" && (
        <>
          <div className="ahp-reservation-row" style={{ marginTop: 10 }}>
            <div className="ahp-reservation-label"></div>
            <div
              className="ahp-reservation-value"
              style={{ backgroundColor: "black", color: "white" }}
            >
              {info.t("transfer")}
            </div>
          </div>
          <div className="ahp-reservation-row">
            <div className="ahp-reservation-label">{info.t("local")}</div>
            <div className="ahp-reservation-value">{info.t(transfer_loc)}</div>
          </div>
          <div className="ahp-reservation-row">
            <div className="ahp-reservation-label">{info.t("date")}</div>
            <div className="ahp-reservation-value">{pickup_date}</div>
          </div>
          <div className="ahp-reservation-row">
            <div className="ahp-reservation-label">{info.t("time")}</div>
            <div className="ahp-reservation-value">{transfer_time}</div>
          </div>
        </>
      )}
      <div className="ahp-reservation-row" style={{ marginTop: 10 }}>
        <div className="ahp-reservation-label"></div>
        <div
          className="ahp-reservation-value"
          style={{ backgroundColor: "black", color: "white" }}
        >
          {info.t("pickup")}
        </div>
      </div>
      <div className="ahp-reservation-row">
        <div className="ahp-reservation-label">{info.t("local")}</div>
        <div className="ahp-reservation-value">{pickup_loc}</div>
      </div>
      <div className="ahp-reservation-row">
        <div className="ahp-reservation-label">{info.t("date")}</div>
        <div className="ahp-reservation-value">{pickup_date}</div>
      </div>
      <div className="ahp-reservation-row">
        <div className="ahp-reservation-label">{info.t("time")}</div>
        <div className="ahp-reservation-value">{pickup_time}</div>
      </div>
      <div className="ahp-reservation-row" style={{ marginTop: 10 }}>
        <div className="ahp-reservation-label"></div>
        <div
          className="ahp-reservation-value"
          style={{ backgroundColor: "black", color: "white" }}
        >
          {info.t("return")}
        </div>
      </div>
      <div className="ahp-reservation-row">
        <div className="ahp-reservation-label">{info.t("local")}</div>
        <div className="ahp-reservation-value">{return_loc}</div>
      </div>
      <div className="ahp-reservation-row">
        <div className="ahp-reservation-label">{info.t("date")}</div>
        <div className="ahp-reservation-value">{return_date}</div>
      </div>
      <div className="ahp-reservation-row">
        <div className="ahp-reservation-label">{info.t("time")}</div>
        <div className="ahp-reservation-value">{return_time}</div>
      </div>

      {(product.gen_price && product.gen_price !== 0) ||
      (product.total_price && product.total_price !== 0) ? (
        <div>
          <hr style={{ width: "80%" }} />
          <div className="ahp-reservation-row">
            <div className="ahp-reservation-label">{info.t("price")}</div>
            <div className="ahp-reservation-value">{product.total_price} €</div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default RentacarReservationInfo;
